import { Badge } from 'src/design/atoms/Badge';
import { Group } from 'src/design/atoms/Group';
import { LoadingOverlay } from 'src/design/atoms/LoadingOverlay';
import { Paper } from 'src/design/atoms/Paper';
import { Title } from 'src/design/atoms/Title';
import { Table } from 'src/design/molecules/Table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useJobs } from 'src/hooks/useJobs';
import { LinkButton } from 'src/design/atoms/LinkButton';
import { BadgeShortList } from 'src/design/molecules/BadgeShortList';
import { EmptyState } from 'src/design/atoms/EmptyState';

interface TeamCardProps {
  jobId: number;
}

export const TeamCard: React.FC<TeamCardProps> = ({ jobId }) => {
  const { team, fetchTeam, loadingTeam } = useJobs();
  const navigate = useNavigate();

  React.useEffect(() => {
    fetchTeam();
  }, []);

  const renderTeam = () => {
    if (team.length === 0) {
      return (
        <EmptyState
          header="No Team Members"
          description="No team members have been added to this job"
        />
      );
    }

    const rows = team.map((t) => (
      <Table.Tr key={t.id}>
        <Table.Td>
          {t.user?.firstName} {t.user?.lastName}
        </Table.Td>
        <Table.Td>
          <BadgeShortList
            items={(t.user?.userOrganizationRole ?? []).map((r) => (
              <Badge key={r.id} variant="light" color="blue">
                {r.organizationRole?.name}
              </Badge>
            ))}
            maxItems={3}
          />
        </Table.Td>
      </Table.Tr>
    ));

    return (
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Roles</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    );
  };

  return (
    <Paper p="md" pos="relative">
      <LoadingOverlay visible={loadingTeam} />
      <Group justify="space-between" mb="md">
        <Title order={5}>Project Team</Title>
        <LinkButton size="compact-xs" to={`/jobs/${jobId}/team`}>
          Open
        </LinkButton>
      </Group>
      <div style={{ height: 200, overflow: 'auto' }}>{renderTeam()}</div>
    </Paper>
  );
};
